import React, { useEffect, useState } from "react";
import { getOrganizations } from "../../services/organizations";
import { getBanks } from "../../services/banks";
import { getInsurances } from "../../services/insurances";
import ReactSearchAutocomplete from "./Suggestion/ReactSearchAutocomplete";
import "./styles.css";
// import { item } from 'joi';

export const BankInput = ({ changeHandler, valueItem = "" }) => {
  const [options, setOptions] = useState(null);
  const [value, setValue] = useState(valueItem);

  useEffect(() => {
    async function fetchData() {
      const { data } = await getBanks();
      console.log("ddd==", data);
      let newArr = new Array(data.length);

      for (let index = 0; index < data.length; index++) {
        const bank = data[index];
        newArr[index] = { id: index, label: bank.name, name: bank.name };
      }

      setOptions(newArr);
    }
    fetchData();
  }, []);

  useEffect(() => {
    console.log(value);
  }, [value]);

  useEffect(() => {
    setValue(valueItem);
  }, [valueItem]);

  const formatResult = (item) => {
    return item;
  };

  return (
    <ReactSearchAutocomplete
      inputSearchString={value ? value : ""}
      items={options ? options : [{ id: 0, name: "loading" }]}
      onSearch={(item) => {
        setValue(item);
        changeHandler(item);
      }}
      onSelect={(item) => {
        setValue(item.name);
        changeHandler(item.name);
      }}
      formatResult={formatResult}
      showIcon={false}
      showClear={false}
      styling={{
        borderRadius: "5px",
      }}
    />
  );
};

export const OrganizationInput = ({ changeHandler, valueItem }) => {
  const [options, setOptions] = useState(null);
  const [searchString, setSearchString] = useState("");

  useEffect(() => {
    setSearchString(valueItem || ""); // Sync with parent value
  }, [valueItem]);

  useEffect(() => {
    async function fetchData() {
      const { data } = await getOrganizations();
      const newArr = data.map((org, index) => ({
        id: index,
        label: org.name,
        name: org.name,
      }));
      setOptions(newArr);
    }
    fetchData();
  }, []);

  const formatResult = (item) => {
    return item;
  };

  return (
    <ReactSearchAutocomplete
      inputSearchString={searchString}
      items={options || [{ id: 0, name: "loading..." }]}
      onSearch={(string) => {
        setSearchString(string);
        if (!string) changeHandler(""); // Clear if empty
      }}
      onSelect={(item) => {
        setSearchString(item.name);
        changeHandler(item.name);
      }}
      formatResult={formatResult}
      showIcon={false}
      showClear={false}
      styling={{
        borderRadius: "5px",
      }}
    />
  );
};
export const InsuranceInput = ({ changeHandler }) => {
  const [options, setOptions] = useState(null);
  const [value, setValue] = useState("");

  useEffect(() => {
    async function fetchData() {
      const { data } = await getInsurances();
      let newArr = new Array(data.length);

      for (let index = 0; index < data.length; index++) {
        const organization = data[index];
        newArr[index] = {
          id: index,
          label: organization.name,
          name: organization.name,
        };
      }

      setOptions(newArr);
    }
    fetchData();
  }, []);

  const formatResult = (item) => {
    return item;
  };

  return (
    <ReactSearchAutocomplete
      inputSearchString={value ? value : ""}
      items={options ? options : [{ id: 0, name: "loading" }]}
      onSearch={(item) => {
        setValue(item);
        changeHandler(item);
      }}
      onSelect={(item) => {
        setValue(item.name);
        changeHandler(item.name);
      }}
      formatResult={formatResult}
      showIcon={false}
      showClear={false}
      styling={{
        borderRadius: "5px",
      }}
    />
  );
};
